/**
 * Tailwind-based Carousel Component
 * Replaces Bootstrap carousel functionality
 */

let currentSlide = 0;
let totalSlides = 0;
let autoPlayInterval = null;
let carouselElement = null;

function initializeTailwindCarousel() {
	carouselElement = document.getElementById('eventsCarousel');

	// Exit early if no carousel exists on this page
	if (!carouselElement) return;

	const carouselItems = carouselElement.querySelectorAll('.carousel-item');

	totalSlides = carouselItems.length;
    
	// Set initial position
	updateCarouselPosition();
    
	// Add auto-play functionality
	startAutoPlay();
    
	// Pause auto-play on hover
	carouselElement.addEventListener('mouseenter', stopAutoPlay);
	carouselElement.addEventListener('mouseleave', startAutoPlay);
}

function startAutoPlay() {
	if (autoPlayInterval) return;
    
	autoPlayInterval = setInterval(() => {
		changeSlide(1);
	}, 5000); // Change slide every 5 seconds
}

function stopAutoPlay() {
	if (autoPlayInterval) {
		clearInterval(autoPlayInterval);
		autoPlayInterval = null;
	}
}

function changeSlide(direction) {
	if (totalSlides === 0) return;
    
	currentSlide += direction;
    
	// Handle wrapping
	if (currentSlide >= totalSlides) {
		currentSlide = 0;
	} else if (currentSlide < 0) {
		currentSlide = totalSlides - 1;
	}
    
	updateCarouselPosition();
}

function updateCarouselPosition() {
	const carouselInner = document.querySelector('.carousel-inner');
	if (!carouselInner) return;
    
	const translateX = -currentSlide * 100;
	carouselInner.style.transform = `translateX(${translateX}%)`;
    
	// Update active class
	const carouselItems = document.querySelectorAll('.carousel-item');
	carouselItems.forEach((item, index) => {
		if (index === currentSlide) {
			item.classList.add('active');
		} else {
			item.classList.remove('active');
		}
	});
}

// Initialize on DOM ready
function init() {
	// Wait a bit for the DOM to be fully ready
	setTimeout(initializeTailwindCarousel, 100);
}

// Make changeSlide globally available for inline onclick handlers
window.changeSlide = changeSlide;

export default init;
